import api from 'common/api';
import {
  SearchSearchPatternRequest,
  DetailSearchPatternRequest,
  UpdateSearchPatternRequest,
  DeleteSearchPatternRequest,
} from 'api-types/src/types/search-pattern';

export const getSqlAPI = (params: SearchSearchPatternRequest) => api.get('/search-pattern/list', params);

export const getSqlDetailAPI = (params: DetailSearchPatternRequest) => api.get('/search-pattern/detail', params);

export const addSqlAPI = (params: UpdateSearchPatternRequest) => api.post('/search-pattern', params);

export const updateSqlAPI = (params: UpdateSearchPatternRequest) => api.put('/search-pattern', params);

export const deleteSqlAPI = (params: DeleteSearchPatternRequest) => api.put('/search-pattern/delete', params);
